/* eslint-disable @typescript-eslint/no-explicit-any */
import { ResponseError } from '../../types/response-error';

export const extractErrorFromResponse = async (response: Response) : Promise<ResponseError> => {
    const result: ResponseError = { 
        message: `Could not fetch ${response.url}. Status: ${response.status}`, 
        status: response.status,
    };

    try {
        const text = await tryParseResponseText(response);
        result.response = text;
    }  catch(error) {
        result.response = 'Unable to parse response body.';
    }

    return Promise.resolve(result);
};

const tryParseResponseText = async (response: Response) : Promise<string> => {
    return response.text()
            .then((body: any) => Promise.resolve(body.message ? body.message : body))
            .catch(() => Promise.reject());
}
